import styled from 'styled-components';

export const PartyJackpotWelcomePopupBottomNoteBox = styled.span`
    font-size: 1.2em;
    margin-top: 50px;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin-top: 15px;
        
        @media ${({theme}) => theme.mediaQuery.landscape} {
            text-align: center;
        }
    }
`;
